import Vue from 'vue';
import firebase from 'firebase/app';
import 'firebase/database';

const state = {
  careers: {}
};

const getters = {
  careerList: state => {
    return Object.values(state.careers);
  }
};

// Career section
const mutations = {
  loadCareers(state, payload) {
    state.careers = payload;
  },

  saveCareer(state, payload) {
    Vue.set(state.careers, payload.key, payload);
  },

  deleteCareer(state, payload) {
    Vue.delete(state.careers, payload.key);
  }
};

// Career section

const actions = {
  addCareer({ commit }, payload) {
    const careersRef = firebase.database().ref('content/careers/');
    const newPostRef = careersRef.push();
    const updatedPayload = {
      key: newPostRef.key,
      ...payload
    };

    newPostRef.set(updatedPayload, error => {
      if (error) {
        // The write failed...
        commit('showMessage', {
          type: 'error',
          message: 'Error saving New Career, Try again!'
        });
      } else {
        // Data saved successfully!
        commit('showMessage', { message: 'New Career saved successfully!' });
        commit('saveCareer', updatedPayload);
      }
    });
  },

  saveCareer({ commit }, payload) {
    firebase
      .database()
      .ref('content/careers/' + payload.key)
      .set({ ...payload }, error => {
        if (error) {
          // The write failed...
          commit('showMessage', {
            type: 'error',
            message: 'Error saving New Career, Try again!'
          });
          console.log(error);
        } else {
          commit('showMessage', { message: 'Career saved successfully!' });
          commit('saveCareer', payload);
        }
      });
  },

  deleteCareer({ commit }, payload) {
    firebase
      .database()
      .ref('content/careers/' + payload.key)
      .set(null, error => {
        if (error) {
          // The write failed...
          commit('showMessage', {
            type: 'error',
            message: 'Error deleting Career, Try again!'
          });
          console.log(error);
        } else {
          commit('showMessage', { message: 'Career deleted successfully!' });
          commit('deleteCareer', payload);
        }
      });
  }
};

export default { state, getters, actions, mutations };



// WEBPACK FOOTER //
// ./src/store/careers.js